import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi } from '@/api/base'
import { CONTRACT_URL } from '../index'

export const CONTRACT_PROJECT_URL = `${CONTRACT_URL}-project`

const errors = createBaseResponseErrors('проект', 'проектов')

export const ContractProjectApi = createBaseCRUDApi(CONTRACT_PROJECT_URL, errors)
